import React, { Component } from 'react'
import "./projectinfo.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import 'antd/dist/antd.css';
import { getApigetCuslocationInfo } from "../../axios/api"
import { UrlSearch } from '../../axios/localstorage';


export default class projectinfo extends Component {


    state = {
        data:{},
        currentIndex:0,
        type:0,

        newsType:1,

        page:1,
        total:11,

        alert:false,

        content:`<p> 	中科合创(北京)科技成果评价中心是我国科技成果评价领域的领军机构，是经科技部有关部门批准成立的全国第一家第三方专业科技成果评价机构，是工信部认定的国
        家军民融合科技评估机构，也是全国唯一一家与公安部科技信息所联合开展全国公安系统和社会公共安全领域科技成果评价的第三方专业评价机构。经过10年的发展，
        中科合创现拥有专职员工400余人，在全国拥有52个工作站和14个分中心，服务区域以北京为中心覆盖全国。 　　
        中科合创始终坚持“专业、权威、客观、公正”的理念，与科技部有关部门、中国标准化研究院等单位共同起草制定了多项有关科技成果评价的国家标准和行业标准，
        率先在国内实现了评价结论的“可追溯、可查询”，成为我国科技成果评价行业内重大成果评价案例最多、评价结论认可度最高的第三方专业成果评价机构。
</p>`,

        
    }

    componentWillMount(){

        window.scroll(0,0);

    }

    componentDidMount(){
        let id = UrlSearch('id');
        this.getInfo(id);
    }   

    getInfo=(id)=>{
        let param = {
            id
        }

        getApigetCuslocationInfo(param)
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    data:req.data.data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    gotochangeType=(type)=>{
        let name = "type"+type;
        let div = document.getElementById(name);
        let  h = div.offsetTop - 180;
        // console.log(h);
        window.scroll(0,h);
        this.setState({
            type
        })
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    } 

    render() {
        return (
            <div className='projectinfo'>
                <Header type={1} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p className='i_point' onClick={()=>{this.gotoPage('/project')}}>潜在招商项目</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>潜在招商项目详情</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='hinfo'>
                    <div className='cen'>
                        <div className='main'>
                            
                            <div className='mtext'>
                                <div className='minfo'>
                                    <h2>{this.state.data.title}</h2>
                                    <p>意向区域：{this.state.data.intention} ｜ 产业类型：{this.state.data.industry_text}</p>
                                </div>
                                <div className='mspan'></div>
                                <div className='mdiv'>
                                    <h2>{this.state.data.investment}万元</h2>
                                    <p>投资总额</p>
                                </div>
                                <div className='mspan'></div>
                                <div className='mdiv'>
                                    <h2>{this.state.data.revenue}万元</h2>
                                    <p>预期税收</p>
                                </div>
                                <div className='mspan'></div>
                                <div className='mdiv'>
                                    <h4>{this.state.data.createtime}</h4>
                                    <p>发布时间</p>
                                </div>
                                <div className='mspan'></div>
                            </div>
                            <div className='mlogo' onClick={()=>{this.setState({alert:true})}}>
                                <div className='cen'>
                                    <div className='mimg' style={{backgroundImage:"url('"+this.state.data.code_img+"')"}}></div>
                                </div>
                                {/* <p>扫码解锁</p> */}
                                <div className='mbtn'>
                                扫码解锁
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='ptype'>
                                <div className='pflex'>
                                    <div onClick={()=>{this.gotochangeType(0)}} className={this.state.type === 0?'pfi pf_active':"pfi"} style={this.state.type === 0?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>项目信息</p>
                                        <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                    </div>
                                    <div onClick={()=>{this.gotochangeType(1)}}  className={this.state.type === 1?'pfi pf_active':"pfi"} style={this.state.type === 1?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>详细信息</p>
                                        <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                    </div>
                                    <div onClick={()=>{this.gotochangeType(2)}}  className={this.state.type === 2?'pfi pf_active':"pfi"} style={this.state.type === 2?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>联系名片</p>
                                        <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                    </div>
                                </div>
                            </div>

                            <div className='name' id="type0">
                            <img alt="" src="/www/assets/imgs/lei.png" />
                                <h2>项目信息</h2>
                            </div>

                            <div className='info'>
                                <div className='text' hidden={!this.state.data.demand_text}>
                                    <h1>需求类型</h1>
                                    <p>{this.state.data.demand_text}</p>
                                </div>
                                <div className='text'>
                                    <h1>产业</h1>
                                    <p>{this.state.data.industry_text}</p>
                                </div>
                                <div className='text' hidden={!this.state.data.demand_mode_text}>
                                    <h1>需求方式</h1>
                                    <p>{this.state.data.demand_mode_text}</p>
                                </div>
                                <div className='text' hidden={!this.state.data.area}>
                                    <h1>需求面积</h1>
                                    <p>{this.state.data.area}m²</p>
                                </div>
                                <div className='text' hidden={!this.state.data.intention}>
                                    <h1>意向区域</h1>
                                    <p>{this.state.data.intention}</p>
                                </div>
                                <div className='text' hidden={!this.state.data.investment}>
                                    <h1>预期投资</h1>
                                    <p>{this.state.data.investment}</p>
                                </div>
                                <div className='text' hidden={!this.state.data.revenue}>
                                    <h1>预期税收</h1>
                                    <p>{this.state.data.revenue}</p>
                                </div>
                                <div className='cont' hidden={!this.state.data.info}>
                                    <h1>项目介绍</h1>
                                    <div className='cdiv'>
                                    {this.state.data.info}
                                    </div>
                                </div>
                            </div>

                            <div className='name' id="type1">
                            <img alt="" src="/www/assets/imgs/lei.png" />
                                <h2>详细信息</h2>
                            </div>

                            <div className='info'>
                                <div className='text'>
                                    <h1>企业名称</h1>
                                    <p hidden>{this.state.data.company}</p>
                                    <div onClick={()=>{this.setState({alert:true})}}>
                                        <img alt='' src="/www/assets/imgs/jiesuo.png" />
                                        <h4>扫码后解锁</h4>
                                    </div>
                                </div>
                                <div className='text'>
                                    <h1>企业类型</h1>
                                    <div onClick={()=>{this.setState({alert:true})}}>
                                        <img alt='' src="/www/assets/imgs/jiesuo.png" />
                                        <h4>扫码后解锁</h4>
                                    </div>
                                </div>
                                <div className='text'>
                                    <h1>来源区域</h1>
                                    <p>{this.state.data.source}</p>
                                </div>
                                <div className='text'>
                                    <h1>选址目的</h1>
                                    <p>{this.state.data.purpose_text}</p>
                                </div>
                                <div className='text'>
                                    <h1>企业特征</h1>
                                    <p>{this.state.data.features_text}</p>
                                </div>
                                <div className='cont'>
                                    <h1>企业介绍</h1>
                                    <div className='cdiv' onClick={()=>{this.setState({alert:true})}}>
                                        <p className='blur'>{this.state.data.com_info}</p>
                                        <div className='cmark'>
                                            <div>
                                                <img alt='' src="/www/assets/imgs/jiesuo.png" />
                                                <h4>扫码后解锁</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='name' id="type2">
                            <img alt="" src="/www/assets/imgs/lei.png" />
                                <h2>联系名片</h2>
                            </div>

                            <div className='card'>
                                <div className='cinfo blur'>
                                    <div className='ctop'>
                                        <h2>{this.state.data.enter_name}</h2>
                                        <p>{this.state.data.enter_company}-{this.state.data.enter_position}</p>
                                    </div>
                                    <div className='cdiv'>
                                        <div className='citem'>
                                            <h2>手机</h2>
                                            <p>15151789221</p>
                                        </div>
                                        <div className='citem'>
                                            <h2>邮箱</h2>
                                            <p>10992009102@qq.com</p>
                                        </div>
                                        <div className='citem'>
                                            <h2>座机</h2>
                                            <p>222-2039291092</p>
                                        </div>
                                        <div className='citem'>
                                            <h2>微信</h2>
                                            <p>{this.state.data.enter_mobile}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='cmark' onClick={()=>{this.setState({alert:true})}}>
                                    <div>
                                        <img alt='' src="/www/assets/imgs/jiesuo.png" />
                                        <h4>扫码后解锁</h4>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className='alert' hidden={!this.state.alert}>
                    <div className='abox'>
                        <img alt="" onClick={()=>{this.setState({alert:false})}} className='aclose' src="/www/assets/imgs/chacha.png" />
                        <div className='aimg' style={{backgroundImage:"url('"+this.state.data.code_img+"')"}}></div>
                        <p>扫一扫关注灵一招商小程序</p>
                        <p>解锁更多详细信息</p>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}
